module.exports = __webpack_public_path__ + "static/media/RecomendaSP.997ce2ba.jpg";